/*
Sohel 10/26/2022 3031450488 Added Filter information table.
Prakash 10/29/2022 3031450488 Removed Toolbar for Table.
Ashraf 10/30/2022 3031450488 fixed table pagination issue
Sohel 10/31/2022 3031450488 Expression value changes
akhila 11/24/2022 3031450488 removed createdBy column
suresh peddavoora 03/23/2023 3031450488 textfield alignments fixes
uday 16/10/2023 3031450488 add scroll for table
*/
import React, {createRef} from 'react';
import MaterialTable from 'material-table';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {useSelector} from 'react-redux';
export default function FilterTable({ruleGroupId}) {
  const {filterRuleGroupData} = useSelector(({addRuleGroup}) => addRuleGroup);

  const editable =
    filterRuleGroupData?.filterSQLRuleResponse?.length > 0 ?
      filterRuleGroupData?.filterSQLRuleResponse?.map((o) => ({...o})) :
      [];

  const columns = [
    {
      title: 'Rule Code',
      field: 'ruleCode',
      render: (rowData) => (rowData?.ruleCode ? rowData?.ruleCode?.toUpperCase() : '-'),
    },
    {
      title: 'Expression',
      field: 'sqlExpression',
      render: (rowData) => (rowData?.sqlExpression ? rowData?.sqlExpression : '-'),
    },
  ];
  const tableRef = createRef();

  //   const editable = fieldListData?.globalFieldsList?.map((o) => ({ ...o }));

  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table custom-actions-icon custom-toolbar-icons global-field-table new-standard-textfields tablescroll-block">
          <MaterialTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={editable}
            tableRef={tableRef}
            textAlign="left"
            options={{
              toolbar: false,
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              paging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={[15, 20, 25]}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                  }}
                />
              )}}
          />
        </div>
      </Grid>
    </>
  );
}
